import { mapGetters } from 'vuex'

export default {
  ...mapGetters(['userIsCompany'])
}



// WEBPACK FOOTER //
// ./src/app/professional/agenda/agendas/form/resources/computed.js